import { ROUTES } from '../constants/routes'
import cleanString from './cleanString'

export const createItemListSchema = (items = []) => {
  const numberOfItems = items.reduce(
    (acc, item) => acc + (item && item.value ? item.value.length : 0),
    0
  )
  let index = 0
  const list = items
    .map((item) =>
      item.value?.map((itemInner) => {
        index += 1
          let image = ""
          if (itemInner.featuredImage) {
            image =
`"image": {
      "@type": "ImageObject",
      "url": "${itemInner.featuredImage.originalSrc}", 
      "caption":"${itemInner.featuredImage?.altText || "No product image"}"
    },`
          } else {
            image =
`"image": {
      "@type": "ImageObject",
      "url": "https://placehold.co/400x400?text=No%20Image", 
      "caption":"No product image"
    },`
          }
        return `
{
  "@type": "ListItem",
  "position": ${index},
  "item": {
    "@type": "Product",
    "name": "${cleanString(itemInner.title)}",
    "url": "${process.env.GATSBY_HELIGUY_DOMAIN}${ROUTES.PRODUCTS}/${itemInner.handle}",
    ${image}
    "category": "${item.title}",
    "offers": {
      "@type": "Offer",
      "price": "${itemInner.priceRangeV2?.minVariantPrice?.amount}",
      "priceCurrency": "${itemInner.priceRangeV2?.minVariantPrice?.currencyCode}"
    }
  }
}`
      })
    )
    .flat()

  return `{
  "@context": "https://schema.org",
  "@type": "ItemList",
  "itemListOrder": "https://schema.org/ItemListOrderAscending",
  "numberOfItems": ${numberOfItems},
  "itemListElement": [${list.join(',')}]
}`
}
